import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewActivity = () => { 
    return useQuery({ 
        queryKey: ['viewActivityReport'], 
        queryFn: async () => { 
            const res = await api.get('/auditlogs', {
            }); 
            return res.data; 
        }
     });
};  